export var ConfigurationSetting;
(function (ConfigurationSetting) {
    /**
     * Data type of the setting value.
     */
    let type;
    (function (type) {
        type["BOOLEAN"] = "boolean";
        type["STRING"] = "string";
        type["NUMBER"] = "number";
    })(type = ConfigurationSetting.type || (ConfigurationSetting.type = {}));
})(ConfigurationSetting || (ConfigurationSetting = {}));
